import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrdersReportsPage } from '@/pages/orders/reports/OrdersReportsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// Range held in URL state so a report is shareable by link; absent means the server's last-90-days default.
const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

const ordersReportsSearchSchema = z.object({
	from: isoDate,
	to: isoDate,
});

export const Route = createFileRoute('/_authenticated/_app/orders/reports')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['orders.readReports'], redirectTo: '/dashboard' }),
	component: OrdersReportsPage,
	validateSearch: ordersReportsSearchSchema,
});
